import Icon from '@atoms/Icon/Icon';
import { Label, Slider, SliderThumb, SliderTrack } from 'react-aria-components';

export type GridSize = 0 | 50 | 100;

interface Props {
  readonly label?: string;
  readonly setValue: (size: GridSize) => void;
  readonly value: GridSize;
}

const GridSlider = ({ value, setValue, label = 'Grid Slider' }: Props) => (
  <Slider
    minValue={0}
    maxValue={100}
    step={50}
    defaultValue={50}
    value={value}
    onChange={setValue}
  >
    <Label className="tw-sr-only">{label}</Label>
    <div className="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-1 rtl:tw-flex-row-reverse">
      <button
        // TODO: localise labels
        aria-label="reduce grid size"
        onClick={(e) => {
          e.preventDefault();
          setValue(value === 0 ? 0 : ((value - 50) as GridSize));
        }}
      >
        <Icon
          name="large-grid"
          size="1.5rem"
          className={value < 100 ? 'tw-fill-grey-100' : 'tw-fill-grey-40'}
        />
      </button>
      <div className="tw-w-full tw-px-xxs md:tw-w-[264px] lg:tw-w-[240px]">
        <SliderTrack className="tw-h-[2px] tw-w-full tw-bg-grey-40">
          <span
            className="tw-absolute tw-left-0 tw-h-[2px] tw-bg-grey-100"
            style={{ width: `${value}%` }}
          />
          <SliderThumb className="tw-h-xs tw-w-xs tw-cursor-grab tw-rounded-full tw-bg-grey-100 tw-transition-all" />
        </SliderTrack>
      </div>
      <button
        // TODO: localise labels
        aria-label="increase grid size"
        onClick={(e) => {
          e.preventDefault();
          setValue(value === 100 ? 100 : ((value + 50) as GridSize));
        }}
      >
        <Icon
          name="small-grid"
          size="1.5rem"
          className={value === 100 ? 'tw-fill-grey-100' : 'tw-fill-grey-40'}
        />
      </button>
    </div>
  </Slider>
);

export default GridSlider;
